<template>
  <div :class="wrapperClass">
    <multiselect v-model="timezone"
                 :allow-empty="false"
                 :options="timezone_list"
                 placeholder="Select a timezone"
                 label="zone"
                 track-by="zone"
                 :show-labels="false"
                 class="timezone-multiselect">
      <template #option="props">
        {{ props.option.zone }}
        <span class="timezone-offset-label">{{ props.option.offset }}</span>
      </template>
    </multiselect>

    <div class="input-group-append">
      <button class="btn btn-ss-standout" @click="updateTimezone()">
        Save
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    wrapperClass: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    timezone_list: window.timezones,
    timezone: { zone: window.user.timezone },
  }),
  methods: {
    updateTimezone: _.debounce(async function () {
      try {
        const response = await axios.patch(
          `/api/v1/user/preference/update`,
          {
            col: "timezone",
            val: this.timezone.zone,
            level: 'user',
          },
        );

        if (response.data.success) {
          if (this.timezone) {
            toastr.success(`Timezone updated to : ${this.timezone.zone}`);
          } else {
            toastr.success("Timezone preference removed");
          }
        }
      } catch (error) {
        toastr.error("Failed to update timezone!");
      }
    }, 1000),
  },
};

</script>

<style lang="scss" scoped>
  .timezone-multiselect {
    width: 80%;
  }
  .multiselect--active {
        z-index: 1000;
  }
  .timezone-offset-label {
    font-size: x-small;
    padding: 2px;
    color: #000;
  }
</style>
